skrilla.directive('userEmails', function () {
    return {
        templateUrl: 'directives/userEmails/userEmails.html',
        scope: {
            user: "="
        },
        controller: function ($scope, searchService) {
            $scope.get = function() {
                searchService.get("communicationChannels/" + $scope.user.id).then(function (response) {
                    $scope.channels = response.data;
                    $scope.emailUnsubscribed = response.data.find(e => e.channel == 'EMAIL' && e.unsubscribed) != null
                });
            }
            $scope.get()

            $scope.updateSubscription = function(){
                var request = $scope.emailUnsubscribed ? "deleteRequest" : "put";
                searchService[request]("emailSubscriptions/" + $scope.user.email + "/emailUnsubscribed").then(function(response){
                    swal("Success!", "Email subscription status successfully updated!", "success");
                    $scope.get()
                })
            }

            $scope.getPasswordReset = function(){
                searchService.get("users/" + $scope.user.id + "/resetPasswordToken").then(function(response){
                    if(response.data.length === 0){
                        swal("Error!", "User has no active password reset tokens.", "error");
                        delete $scope.reset;
                    }
                    else {
                        $scope.reset = response.data;
                        $scope.reset.url = "https://picklebet.com/forgot-password?reset=" + $scope.reset.id;
                        $scope.reset.expired = moment().diff(moment.utc($scope.reset.createdAt), 'minutes') > 30

                    }
                })
            }

        }
    };
});
